import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import React from "react";
import { Button, Col, Container, Row } from "reactstrap";
import ModalFrame from "../../../../toolkit/modalFrame";
import TextWithLineBreaks from "../TextWithLineBreaks";
import s from "./iFrameModal.scss";

interface Props {
  isOpen: boolean;
  title: String;
  message: String;
  size: String;
  okTitle: String;
  cancelTitle: String;
  src: string;
  waiting: boolean;
  ok: () => void;
  cancel: () => void;
}

class IFrameModal extends React.Component<Props> {
  render() {
    return (
      <ModalFrame
        title={this.props.title}
        isOpen={this.props.isOpen}
        toggle={() => this.props.cancel()}
        size={this.props.size || "lg"}
      >
        <Container style={{ width: "90%" }} className="center-block p-0 mb-3">
          {!!this.props.message && (
            <TextWithLineBreaks text={this.props.message} />
          )}

          <div className="m-4">
            <iframe
              src={this.props.src}
              style={{
                background: "#fff",
                width: "100%",
                minHeight: "700px",
                border: "0px solid #fff"
              }}
            />
          </div>

          <Row className="m-5">
            <Col xs="12" md="6">
              {!!this.props.ok && (
                <Button
                  className={`${s.primaryButton} mt-3`}
                  onClick={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.props.ok();
                    this.setState({ value: null });
                  }}
                  block
                  disabled={!!this.props.waiting}
                >
                  {!!this.props.waiting && (
                    <FontAwesomeIcon icon={faSpinner} pulse />
                  )}
                  {!this.props.waiting && (this.props.okTitle || "Aceptar")}
                </Button>
              )}
            </Col>

            <Col xs="12" md="6">
              <Button
                className={`${s.secundaryButton} mt-3`}
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  this.setState({ value: null });
                  this.props.cancel();
                }}
                block
                disabled={!!this.props.waiting}
              >
                {this.props.cancelTitle || "Cancelar"}
              </Button>
            </Col>
          </Row>
        </Container>
      </ModalFrame>
    );
  }
}

export default withStyles(s)(IFrameModal);
